import React from 'react';
import { Grid, CardMedia, CardContent, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { styles } from './styles';
import Loader from '../../components/Loader';
import { connect } from 'react-redux';

class Story extends React.Component {
  render() {
    const { classes, story } = this.props;
    if (!story) {
      return <Loader />;
    } else {
      return (
        <CardContent className={classes.story}>
          <CardMedia>
            <img alt='logo' my={5} height='120' src={story.tenantLogoURL} />
          </CardMedia>

          <Typography variant='h5' my={5} component='h2'>
            {story.title}
          </Typography>

          <Grid container className={classes.storyContent}>
            <Grid item xs={12} md={6}>
              <CardMedia>
                <img src={story.picture} alt={story.title} className={classes.picture} />
              </CardMedia>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography className={classes.text} variant='body2' color='textSecondary' component='p'>
                {story.description}
              </Typography>
            </Grid>
          </Grid>
          <img
            src='https://stych-serverless-dev-serverlessdeploymentbucket-1rwcf3p24cgp1.s3-eu-west-1.amazonaws.com/Graphic%402x.png'
            alt='howTo'
            className={classes.howTo}
          />
        </CardContent>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    story: state.storyDetailsReducer.story
  };
};

const withConnect = connect(
  mapStateToProps,
  null
)(Story);

export default withStyles(styles)(withConnect);
